import { MdHeadsetMic } from "react-icons/md";
import logo from "../../Assets/images/logo.png";
import Progress from "../Progress";
import Actions from "./Actions";

const Navbar = ({
  progress = 0,
  project,
  showCart,
  showHelp,
  showProfile,
  tracer,
  priceLoading,
}) => {
  return (
    <div className="miltis-navbar">
      <div className="miltis-navbar__header">
        <div className="miltis-navbar__logo">
          <img src={logo} alt="Miltis" />
        </div>
        <div className="miltis-navbar__actions">
          <Actions
            project={project}
            showCart={showCart}
            showHelp={showHelp}
            showProfile={showProfile}
            tracer={tracer}
            priceLoading={priceLoading}
          />
        </div>
      </div>
      <Progress value={progress} />
    </div>
  );
};

Navbar.propTypes = {};

export default Navbar;
